import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "48th House & Condo Expo Bangkok";
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl text-center">48th House & Condo Expo Bangkok</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-6 rounded-lg border text-center space-y-3 flex flex-col justify-between">
              <h2 className="font-semibold">
                Register
                <br />
                ลงทะเบียน
              </h2>
              <p className="text-sm text-muted-foreground">
                Sign up to attend the expo
                <br />
                สมัครเข้าร่วมงานมหกรรมบ้านและคอนโด
              </p>
              <Button className="w-full" onClick={() => navigate("/register")}>
                Start Registration
              </Button>
            </div>
            <div className="p-6 rounded-lg border text-center space-y-3 flex flex-col justify-between">
              <h2 className="font-semibold">
                Look up Registration
                <br />
                ค้นหาข้อมูลการลงทะเบียน
              </h2>
              <p className="text-sm text-muted-foreground">
                Retrieve your registration, QR, or edit your information
                <br />
                ดึงข้อมูลการลงทะเบียน QR หรือแก้ไขข้อมูล
              </p>
              <Button variant="outline" className="w-full" onClick={() => navigate("/lookup")}>
                Check Registration
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="mt-6 text-center">
        <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground">
          <button
            onClick={() => navigate("/admin")}
            className="hover:text-foreground hover:underline"
          >
            Admin Login
          </button>
          <span>|</span>
          <button
            onClick={() => navigate("/dashboard")}
            className="hover:text-foreground hover:underline"
          >
            Insights Login
          </button>
        </div>
      </div>
    </div>
  );
}
